/**
 * Browser-side profile store. No accounts, no backend persistence.
 * Lives in localStorage as `aw_profile_v1`.
 */

const KEY = "aw_profile_v1";

const DEFAULT = {
  name: "",
  home_state: "",
  income_bracket: "",
  gpa: "",
  graduation_year: 2026,
  application_cycle: "2025-2026",
  college_list: [],
  // money saver completion tracking
  saver_completed: [],
};

export function getProfile() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT, ...parsed };
  } catch {
    return { ...DEFAULT };
  }
}

export function setProfile(patch) {
  const cur = getProfile();
  const next = { ...cur, ...patch };
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch {}
  return next;
}

export function clearProfile() {
  try { localStorage.removeItem(KEY); } catch {}
}

export function profileForApi(p) {
  // Normalize for backend StatelessProfile model
  const out = {};
  if (p.name) out.name = p.name;
  if (p.home_state) out.home_state = p.home_state.toUpperCase();
  if (p.income_bracket) out.income_bracket = p.income_bracket;
  if (p.gpa !== "" && p.gpa !== null && p.gpa !== undefined) out.gpa = Number(p.gpa);
  if (p.graduation_year) out.graduation_year = Number(p.graduation_year);
  if (p.application_cycle) out.application_cycle = p.application_cycle;
  if (Array.isArray(p.college_list) && p.college_list.length) {
    out.college_list = p.college_list
      .filter((c) => c && c.name && c.name.trim().length >= 2)
      .map((c) => {
        const row = { name: c.name.trim(), plan: c.plan || "unknown" };
        if (c.residency === "in_state" || c.residency === "out_of_state") {
          row.residency = c.residency;
        }
        return row;
      });
  }
  return out;
}

export const PROFILE_STORAGE_KEY = KEY;
